export const notificationsReducer = (state, action) => {
  switch (action.type) {
    case "ADD_NOTIFICATION":
      // return [...state, action.newEvents];
      return [...action.newEvents];
    case "REMOVE_NOTIFICATION":
      return state;
    default:
      return state;
  }
};
